<template>
	<div v-if="isUserAllowedInLevel5or6 || isUserAllowedInLevel1">
		<BaseHeader :title="$t('employee_app').toString()" :subtitle="$t('scan_qr_code_to_download_app').toString()"/>
		<div v-if="!isLoading" class="main">
			<div class="w-full grid grid-cols-2">
				<div class="border-r-2 border-gray-400 w-full">
					<div class="font-bold mb-4 justify-start text-left" style="font-size: 18px">
						{{ $t('ios') }}
					</div>
					<div class="w-1/2">
						<img src="../../../assets/qr-code-employee-ios.svg" alt="QR Code Connect Assist iOS" class="w-full" />
					</div>
				</div>
				<div class="w-full ml-8">
					<div class="font-bold mb-4 justify-start text-left" style="font-size: 18px">
						{{ $t('android') }}
					</div>
					<div class="w-1/2">
						<img src="../../../assets/qr-code-employee-android.svg" alt="QR Code Connect Assist Android" class="w-full" />
					</div>
				</div>
			</div>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'EmployeeApp',
	components: { Forbidden, BaseHeader },
	mixins: [Authentication],
	data() {
		return {
			isLoading: false,
		};
	},
	mounted() {},
	methods: {},
};
</script>
